import React from 'react';
import { CountryFlag, DateString, NumberString, PriceString } from '@fourthwall/components';
const analyzeDateRange = (timezonedDateRange) => {
    const [startDate, endDate] = timezonedDateRange;
    const isSameDay = startDate.isSame(endDate, 'day');
    const isSameMonth = startDate.isSame(endDate, 'month');
    const isSameYear = startDate.isSame(endDate, 'year');
    return {
        isSameDay,
        isSameMonth,
        isSameYear,
        isLessThanOneDay: isSameDay,
        isMoreThanOneMonth: !isSameMonth,
        isMoreThanOneYear: !isSameYear,
    };
};
const getDateFormat = (precision, rangeAnalysis) => {
    const formatMap = {
        hour: {
            sameDay: 'h:mm A',
            multiDay: 'MMM D h:mm A',
        },
        day: {
            sameMonth: 'MMM D',
            sameYear: 'MMM D',
            multiYear: 'MMM D, YYYY',
        },
        month: {
            sameYear: 'MMMM',
            multiYear: 'MMM, YYYY',
        },
    };
    switch (precision) {
        case 'hour':
            return rangeAnalysis.isLessThanOneDay ? formatMap.hour.sameDay : formatMap.hour.multiDay;
        case 'day':
            if (rangeAnalysis.isSameMonth)
                return formatMap.day.sameMonth;
            if (rangeAnalysis.isSameYear)
                return formatMap.day.sameYear;
            return formatMap.day.multiYear;
        case 'month':
            return rangeAnalysis.isSameYear ? formatMap.month.sameYear : formatMap.month.multiYear;
        default:
            return 'MMM D, YYYY';
    }
};
export const formatChartDate = (value, timezonedDateRange, precision) => {
    const rangeAnalysis = analyzeDateRange(timezonedDateRange);
    const format = getDateFormat(precision, rangeAnalysis);
    return React.createElement(DateString, { date: value, format: format });
};
export const formatChartLabel = ({ value, type, timezonedDateRange, precision, }) => {
    if (type === 'date') {
        return formatChartDate(value, timezonedDateRange, precision);
    }
    if (type === 'country') {
        if (value === 'null')
            return 'Unidentified';
        return React.createElement(CountryFlag, { countryCode: value });
    }
    if (type === 'money') {
        return React.createElement(PriceString, { value: value });
    }
    if (type === 'number') {
        return React.createElement(NumberString, { value: Number(value) });
    }
    return value;
};
